<template>
  <v-container>
    <v-card>
      <v-layout row
                wrap>
        <v-flex xs12
                class="pa-2">

          <v-list class="n-lines">
            <v-subheader>Condiciones promoción</v-subheader>
            <v-list-tile v-for="item in items"
                         class="pa-2"
                         :key="item.title">
              <v-list-tile-action>
                <v-icon color="primary">check</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-subtile v-html="item.title"
                                     style="font-size:14px"></v-list-tile-subtile>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'MadridSmartbox',
  data() {
    return {
      items: [
          { title: 'Podrán participar de la presente promoción todos los usuarios de wesmartPark que aparquen 2 veces o más durante el mes de Enero de 2020 en Madrid.' },
          { title: 'No se incluirán en la presente promoción los abonos, tan solo las reservas por horas.' },
          { title: 'Para considerar que un usuario ha aparcado en wesmartPark la reserva debe materializarse. No se aceptarán reservas canceladas como objeto de la promoción.' },
          { title: 'El premio consistirá en el regalo de la siguiente <a href="https://www.smartbox.com/es/nuestras-smartbox/estancias/noche-cena-y-spa-en-el-occidental-aranjuez-de-4-estrellas-en-madrid-1581.html" target="_blank">Smartbox<a/>.' },
          { title: 'Solo se contabilizará una participación por usuario.' },
          { title: 'El 4 de Febrero a las 10:00 am se procederá al sorteo a través de la herramienta sortea2, comunicándose a los participantes el ganador a través de email.' }
        ]
    };
  },
  created() {
  },
  destroyed() {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>
